import { combine, createEvent, createStore } from 'effector';

import { DEFAULT_THEME_SELECTION, resolveThemePreference, type ResolvedTheme, type ThemeSelection } from './logic';

export const themeSelectionHydrated = createEvent<ThemeSelection>();
export const themeSelectionChanged = createEvent<ThemeSelection>();
export const systemPreferenceChanged = createEvent<boolean>();

export const $themeSelection = createStore<ThemeSelection>(DEFAULT_THEME_SELECTION)
    .on(themeSelectionHydrated, (_state, payload) => payload)
    .on(themeSelectionChanged, (_state, payload) => payload);

export const $systemPrefersDark = createStore(true).on(systemPreferenceChanged, (_state, payload) => payload);

export const $resolvedTheme = combine(
    $themeSelection,
    $systemPrefersDark,
    (themeSelection, systemPrefersDark): ResolvedTheme =>
        resolveThemePreference({
            selection: themeSelection,
            prefersDark: systemPrefersDark,
        })
);
